
/**
 * 플랜 상태
 */
export type PlanChangeOptionsResponseUpgradeOptionsItemStatus = typeof PlanChangeOptionsResponseUpgradeOptionsItemStatus[keyof typeof PlanChangeOptionsResponseUpgradeOptionsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanChangeOptionsResponseUpgradeOptionsItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
